// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--x89Rh","item":"item--tge9N","title":"title--Oq4Mj","tip":"tip--nd9Ee","num":"num--H2j9w","activeType":"activeType--mDXW1"};